<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Horizontal Form</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="2" vs-sm="2" vs-xs="12" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              Username
              </vs-col>
              <vs-col vs-lg="10" vs-sm="10" vs-xs="12">
                <vs-input                 
                  class="w-full"
                  v-model="username"
                  placeholder="Username"
                />
              </vs-col>              
            </vs-row> 
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="2" vs-sm="2" vs-xs="12" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              Email
              </vs-col>
              <vs-col vs-lg="10" vs-sm="10" vs-xs="12">
                <vs-input                 
                  class="w-full"
                  v-model="email"
                  placeholder="Email"
                />
              </vs-col>              
            </vs-row> 
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="2" vs-sm="2" vs-xs="12" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              Password
              </vs-col>
              <vs-col vs-lg="10" vs-sm="10" vs-xs="12">
                <vs-input                 
                  class="w-full"
                  type="password"
                  v-model="password"
                  placeholder="****"
                />
              </vs-col>              
            </vs-row>  
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="2" vs-sm="2" vs-xs="12" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              Checkbox
              </vs-col>
              <vs-col vs-lg="10" vs-sm="10" vs-xs="12">
                 <vs-checkbox
                  class="content-start justify-start"
                  v-model="option"
                >
                  Example Checkbox
                </vs-checkbox>
              </vs-col>              
            </vs-row>           
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12" class="left">
                <vs-button> Submit </vs-button>
                <vs-button color="warning" type="border" class="ml-2">Reset</vs-button>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Horizontal Form With Icon</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="2" vs-sm="2" vs-xs="12" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              Username
              </vs-col>
              <vs-col vs-lg="10" vs-sm="10" vs-xs="12">
                <vs-input
                icon="account_box"                  
                  class="w-full"
                  v-model="username"
                  placeholder="Username"
                />
              </vs-col>              
            </vs-row> 
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="2" vs-sm="2" vs-xs="12" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              Email
              </vs-col>
              <vs-col vs-lg="10" vs-sm="10" vs-xs="12">
                <vs-input 
                 icon="mail"                      
                  class="w-full"
                  v-model="email"
                  placeholder="Email"
                />
              </vs-col>              
            </vs-row> 
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="2" vs-sm="2" vs-xs="12" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              Password
              </vs-col>
              <vs-col vs-lg="10" vs-sm="10" vs-xs="12">
                <vs-input  
                icon="vpn_key"               
                  class="w-full"
                  type="password"
                  v-model="password"
                  placeholder="****"
                />
              </vs-col>              
            </vs-row>  
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="2" vs-sm="2" vs-xs="12" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              Checkbox
              </vs-col>
              <vs-col vs-lg="10" vs-sm="10" vs-xs="12">
                 <vs-checkbox
                  class="content-start justify-start"
                  v-model="option"
                >
                  Example Checkbox
                </vs-checkbox>
              </vs-col>              
            </vs-row>           
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12" class="left">
                <vs-button> Submit </vs-button>
                <vs-button color="warning" type="border" class="ml-2">Reset</vs-button>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Vertical Form</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              Username
              </vs-col>
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-input                 
                  class="w-full"
                  v-model="username"
                  placeholder="Username"
                />
              </vs-col>              
            </vs-row> 
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              Email
              </vs-col>
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-input                 
                  class="w-full"
                  v-model="email"
                  placeholder="Email"
                />
              </vs-col>              
            </vs-row> 
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              Password
              </vs-col>
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-input                 
                  class="w-full"
                  type="password"
                  v-model="password"
                  placeholder="****"
                />
              </vs-col>              
            </vs-row>  
            <vs-row vs-w="12" class="mb-3">
            
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                 <vs-checkbox
                  class="content-start justify-start"
                  v-model="option"
                >
                  Example Checkbox
                </vs-checkbox>
              </vs-col>              
            </vs-row>           
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12" class="left">
                <vs-button> Submit </vs-button>
                <vs-button color="warning" type="border" class="ml-2">Reset</vs-button>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Vertical Form With Icon</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              Username
              </vs-col>
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-input
                icon="account_box"                  
                  class="w-full"
                  v-model="username"
                  placeholder="Username"
                />
              </vs-col>              
            </vs-row> 
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              Email
              </vs-col>
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-input 
                 icon="mail"                      
                  class="w-full"
                  v-model="email"
                  placeholder="Email"
                />
              </vs-col>              
            </vs-row> 
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              Password
              </vs-col>
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-input  
                icon="vpn_key"               
                  class="w-full"
                  type="password"
                  v-model="password"
                  placeholder="****"
                />
              </vs-col>              
            </vs-row>  
            <vs-row vs-w="12" class="mb-3">
             
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                 <vs-checkbox
                  class="content-start justify-start"
                  v-model="option"
                >
                  Example Checkbox
                </vs-checkbox>
              </vs-col>              
            </vs-row>           
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12" class="left">
                <vs-button> Submit </vs-button>
                <vs-button color="warning" type="border" class="ml-2">Reset</vs-button>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Multi Column Form</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-row vs-w="12" class="mb-3">
              <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="mb-3" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              <vs-input
                  label="First Name"
                  class="w-full"
                  v-model="fname"
                  placeholder="First Name"
                />
              </vs-col>              
           
              <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="mb-3" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              <vs-input
                  label="Last Name"
                  class="w-full"
                  v-model="lname"
                  placeholder="Last Name"
                />
              </vs-col>     
              <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="mb-3" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              <vs-input
                  label="City"
                  class="w-full"
                  v-model="city"
                  placeholder="City"
                />
              </vs-col>     
              <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="mb-3" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              <vs-input
                  label="State"
                  class="w-full"
                  v-model="state"
                  placeholder="State"
                />
              </vs-col>     
              <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="mb-3" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              <vs-input
                  label="Mobile"
                  class="w-full"
                  v-model="mobile"
                  placeholder="Mobile"
                />
              </vs-col>     
              <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="mb-3" vs-type="flex" vs-justify="flex-start" vs-align="center" >
              <vs-input
                  label="Phone"
                  class="w-full"
                  v-model="phone"
                  placeholder="Phone"
                />
              </vs-col>              
            </vs-row>
            <vs-row vs-w="12">
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12" class="left">
                <vs-button> Submit </vs-button>
                <vs-button color="warning" type="border" class="ml-2">Reset</vs-button>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
require("vue-simple-calendar/static/css/default.css");
require("vue-simple-calendar/static/css/holidays-us.css");
export default {
  components: { Datepicker },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light"; 
      return mode;          
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
      username: "",
      password: "",
      email: "",
      address2: "",
      city: "",
      fname: "",
      lname: "",
      mobile: "",
      phone: "",
      state: "",
      zip: "",
      date: "",
      option: true,
      states: [
        { text: "New York", value: "new-york" },
        { text: "New York", value: "new-york" },
        { text: "New York", value: "new-york" },
      ],
    };
  },
};
</script>